import API from 'services/TAPS_API';

export default function getSntsList() {
  return API.request({
    method: 'GET',
    url: `/dictionary/code-snts`,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
}
